import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']
  static values = { assessmentsControlId: String }

  declare readonly inputTarget: HTMLInputElement
  declare readonly hasInputTarget: boolean
  declare readonly assessmentsControlIdValue: string

  private timeout: number | null = null

  connect (): void {
    // Restore search value from hidden field if it exists (e.g., after slideover replacement)
    const searchInput = document.getElementById('q') as HTMLInputElement | null
    if (this.hasInputTarget && searchInput !== null && searchInput.value !== '') {
      this.inputTarget.value = searchInput.value
    }
  }

  submit (): void {
    if (this.timeout !== null) clearTimeout(this.timeout)

    this.timeout = window.setTimeout(() => {
      this.timeout = null
      const query = this.hasInputTarget ? this.inputTarget.value.trim() : ''

      const searchInput = document.getElementById('q') as HTMLInputElement | null
      if (searchInput !== null) searchInput.value = query

      const url = new URL(`/assessments_controls/${this.assessmentsControlIdValue}/evidence_search`, window.location.origin)
      url.searchParams.set('q', query)

      void this.performSearch(url.toString())
    }, 500)
  }

  private async performSearch (url: string): Promise<void> {
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'text/vnd.turbo-stream.html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      const html = await response.text()
      const Turbo = (window as any).Turbo
      Turbo.renderStreamMessage(html)
    } catch (error) {
      console.error('Evidence search failed:', error)
    }
  }

  reset (): void {
    if (this.hasInputTarget) {
      this.inputTarget.value = ''
    }
    this.submit()
  }
}
